'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); // Aka. "Lähtölista"

// Displays a list of search results, which may be departures or day capacity
// items.
// Takes search criteria from outside, e.g. from a winresDeparturesSearch
// component.

var _module2 = require('../../module');

var _module3 = _interopRequireDefault(_module2);

var _utils = require('../../../core/utils');

var _utils2 = require('../../utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var WinresDeparturesListController = function () {
    function WinresDeparturesListController($document, $scope, $timeout, departureService, localizationService, $attrs, $filter, productService, $window, $rootScope, cancelService, paramService) {
        _classCallCheck(this, WinresDeparturesListController);

        this.needCombination = this.needCombineResults === 'true' ? true : false;
        this.$document = $document;
        this.$filter = $filter;
        this.$scope = $scope;
        this.$rootScope = $rootScope;
        this.$timeout = $timeout;
        this.departureService = departureService;
        this.localizationService = localizationService;
        this.productService = productService;
        this.paramService = paramService;
        this.searchCriteria = null;
        this.hasMore = false;
        this.loading = 0;
        this.data = [];
        this.noResults = false;
        this.noCapacity = false;
        this.spaceLeftText = "";
        this.$window = $window;
        this.firstLoad = true;
        this.forceFullPagereloadWhenGettingResult = false;
        this.cancelService = cancelService;
        this.showProductName = false;
        //this.addUrl = "";
        //this.peopleCount = {};
    }

    _createClass(WinresDeparturesListController, [{
        key: '$onInit',
        value: function $onInit() {
            var _this = this;

            // Dependencies
            // this.winresReservationContext

            // Get:
            // getContext()
            // getContext().Destination
            // getContext().SelectedDeparture
            // getContext().NumAdults
            // getContext().NumChildren
            // getContext().NumInfants
            // getContext().ChildrenAges
            // getSeoState()

            // Other:
            // findOrCreateProductLineByProduct()
            // addExtraServiceToPassenger()
            // findOrCreatePriceSelection()

            // For testing with the new fast departure search
            //this.useSearchDepartures = 'true';

            this.data = this.winresReservationContext.getContext();
            //console.log("[WDL] data", this.data);

            this.useSeoLinks = this.winresReservationContext.getSeoState();
            //console.log("[WDL] this.useSeoLinks: ", this.useSeoLinks);

            if (this.offers === 'true') {
                //console.log("[WinresDeparturesList] Loading offers...");
                var amount = this.amountOfNextDepartures || 6;

                this.searchCriteria = this.searchCriteria || {
                    IsOffer: true,
                    Limit: amount
                };

                this.loadInitial(this.searchCriteria);
            }

            // Make sure it is integer
            if (this.earliestNDeparturesPerDestination && isNaN(parseInt(Number(this.earliestNDeparturesPerDestination)))) {
                console.error("[WDL] EarliestNDeparturesPerDestination is set, but it is not a whole number! Clearing the setting... :", this.earliestNDeparturesPerDestination);
                this.earliestNDeparturesPerDestination = null;
            }

            if (this.nextDepartures === 'true' || this.useCurrentDestination == 'true') {
                //console.log("[WinresDeparturesList] Loading next departures");

                var amount = this.amountOfNextDepartures || 3;
                if (this.useCurrentDestination == 'true') {
                    this.$scope.$watch('$ctrl.data.Destination.DestinationCode', function () {
                        if (_this.data.Destination) {
                            // and extra check this.data.Destination exists..
                            // This was ended up running sometimes when destinationCode was null
                            // Probably because this component was included two times in the (Golfresepti) page product page
                            // The other probaly had  nextDepartures === 'true' and the useCurrentDestination == 'true'
                            _this.loadInitial(_this.searchCriteria || {
                                Limit: amount,
                                DestinationCodes: [_this.data.Destination.DestinationCode],
                                Classifications1: _this.useSpecificClassification != null ? [_this.useSpecificClassification] : [],
                                NumAdults: _this.data.NumAdults,
                                NumChildren: _this.data.NumChildren,
                                NumInfants: _this.data.NumInfants
                            });
                        }
                    });
                } else {
                    this.loadInitial(this.searchCriteria || {
                        Limit: amount,
                        DestinationCodes: null,
                        Classifications1: this.useSpecificClassification != null ? [this.useSpecificClassification] : [],
                        Classifications2: this.useSpecificClassification2 != null ? [this.useSpecificClassification2] : [],
                        StartDate: this.nextStartDate || null,
                        EndDate: this.nextEndDate || null,
                        LengthInDaysMinimum: this.nextMinLength ? this.nextMinLength : null,
                        LengthInDaysMaximum: this.nextMaxLength ? this.nextMaxLength : null,
                        EarliestNDeparturesPerDestination: this.earliestNDeparturesPerDestination ? Number(this.earliestNDeparturesPerDestination) : null
                    });
                }
            }

            //this list is for joiku/minisite, those uses it to display dropdown between 1 and 10
            this.dropdownValues = { '1': 1, '2': 2, '3': 3, '4': 4, '5': 5, '6': 6, '7': 7, '8': 8, '9': 9, '10': 10 };

            // used in ahtari
            if (!this.showReservableAndNotReservable) this.$scope.showOnlyReservable = true;

            // These are the criteria filters copied from winresDestinationFilter
            this.$scope.activeFilters = {
                searchFieldTerm: '',
                searchTerms: [],
                // We need these defined, even if  not used yet, because the search filter expects them defined  (combinedfilter, custom filter in webcomponents/filters/searchFilter)
                numOfBeds: 2,
                numAdults: 2,
                numChildren: 0,
                duration: {
                    startDate: null,
                    endDate: null
                },
                priceRange: {
                    min: null,
                    max: null
                },
                starRatings: {
                    one: false,
                    two: false,
                    three: false,
                    four: false,
                    five: false
                },
                searchCriteriaDefinitions: {
                    // These vary from database to database
                    // So they are fethced in onInit with this.productService.getCriteriaDefs()
                }
            };

            // This is coopied from winresDestinationFilter
            this.productService.getCriteriaDefs().then(function (result) {
                // console.log("[WDL] Got search criteria definitions: " , result);
                _this.$scope.criteriaDefs = result;
                _this.$scope.activeFilters.searchCriteriaDefinitions = result;

                // console.log("[WDL] searchCriteriaDefinitions" , this.$scope.activeFilters.searchCriteriaDefinitions);
            }).catch(function (error) {
                console.error("[WDL] Failed to load search criteria definitions: ", error);
            });

            // What's this?
            // FIXME
            this.$rootScope.$watch("type1", function (type1) {
                if (_this.searchCriteria) {
                    var searchCriteria = JSON.parse(JSON.stringify(_this.searchCriteria));
                    if (!_this.defaultTypes) _this.defaultTypes = searchCriteria.Classifications1;
                    type1 ? searchCriteria.Classifications1 = [type1] : searchCriteria.Classifications1 = _this.defaultTypes;
                    _this.searchCriteria = searchCriteria;

                    if (type1) {
                        // Prevent double request on init.
                        _this.firstLoad = false;
                        _this.loadInitial(searchCriteria);
                    }
                }
            });

            // Check no capacity during first load.
            this.$scope.$on("on-passengers-num-change", function (event, passengers) {
                return _this.checkNoCapacity(passengers);
            });

            this.getNoResultText();

            this.getWinresParams();
        }
    }, {
        key: '$onChanges',
        value: function $onChanges(changes) {
            if (!changes.hasOwnProperty('searchCriteria')) {
                return;
            }
            var searchCriteria = changes.searchCriteria.currentValue;

            console.log("[WDL] Received search criteria.");
            if (searchCriteria != null) {
                if (this.forceFullPagereloadWhenGettingResult || searchCriteria.forceFullPagereloadWhenGettingResult) {
                    this.forceFullPagereloadWhenGettingResult = true;
                } else {
                    this.forceFullPagereloadWhenGettingResult = false;
                }

                this.firstLoad = false;
                this.loadInitial(searchCriteria);

                if (this.$scope.activeFilters) {
                    // this.$scope.activeFilters.numAdults = searchCriteria.NumAdults;
                    // this.$scope.activeFilters.numChildren = searchCriteria.NumChildren;

                    // Beds per adult and child.
                    if (this.$scope.activeFilters) {
                        this.$scope.activeFilters.numOfBeds = searchCriteria.NumAdults + searchCriteria.NumChildren;
                        if (this.$scope.activeFilters.numOfBeds > 2) this.$scope.activeFilters.numOfBeds = 2;
                    }
                }
            }
        }
    }, {
        key: 'reservationLinkPressed',
        value: function reservationLinkPressed(href) {
            if (this.reserveInNewWindow != 'true') {
                window.location.href = href;
                this.$window.location.assign(href);
            }
            //this.$window.location.reload();
            //location.reload();
        }
    }, {
        key: 'checkNoCapacity',
        value: function checkNoCapacity(criteria) {
            if (!criteria) return;
            if (!this.data.SelectedDeparture) return;

            var numPeople = criteria.NumAdults + criteria.NumChildren + criteria.NumInfants;

            var capacity = this.data.SelectedDeparture.CapacityAvailable;
            if (!capacity) capacity = 0;

            if (capacity < numPeople) this.noCapacity = true;else this.noCapacity = false;
        }
    }, {
        key: 'loadInitial',
        value: function loadInitial(searchCriteria) {
            var _this2 = this;

            //console.log("[WDL] loadInitial, searchCriteria: ", searchCriteria);
            this.results = null;

            // Request cancelling if new one is made before previous finished
            if (this.pending) {
                console.log("[WDL] Cancelling previous request.");
                this.cancelService.cancel(this.pending);
                this.pending = null;
            }
            var request = this.load(searchCriteria);
            this.pending = request;
            this.loadingPromise = request;

            request.then(function (results) {
                if (!results) {
                    // Canceled promise.
                    console.log("[WDL] This request was cancelled.");
                    return;
                } else if (request !== _this2.pending) {
                    console.log('[WDL] Ignoring completed request because a newer one is pending.');
                    return;
                }
                _this2.results = [];
                _this2.results = results;
                if (!_this2.firstResults) _this2.firstResults = results;
                // console.log("[WDL] Results:", this.results);

                //this is to handle error about not having any departures
                if (_this2.results.length == 0) _this2.noResults = true;else _this2.noResults = false;

                if (_this2.needCombination) _this2.combineResults();

                //this is to handle error about not having any capacity

                if (searchCriteria.NumAdults) {
                    // undefined url fix.
                    _this2.checkNoCapacity(searchCriteria);

                    // This is used to force reload page when results are received
                    // used for forcing full page reaload when changing amount of persons
                    // on kohdesivu, because the page does not quite work without full reload
                    if (_this2.forceFullPagereloadWhenGettingResult) {
                        console.log("[WDL] Forcing reload.");
                        _this2.forceFullPagereloadFromResults();
                    }
                }
            }).catch(function (error) {
                console.error("[WDL] Error in loadInitial: ", error);
            }).then(function () {
                if (_this2.pending === request) {
                    // The request that just completed was the most recent pending one.
                    // console.log("[WDL] The request that just completed was the most recent pending one.");
                    _this2.pending = null;
                }
            });
        }
    }, {
        key: 'updateDate',
        value: function updateDate(startDate, endDate) {
            startDate = this.$filter('date')(startDate, 'yyyy-M-d');
            endDate = this.$filter('date')(endDate, 'yyyy-M-d');

            var href = window.location.href;
            //href = href.replace("/:tab", "");
            href = href.split("#!")[1];

            var split = href.split("/");
            split[4] = startDate; // replace start date.
            split[5] = endDate; // replace end date.
            href = split.join("/");

            window.location.hash = '#!' + href;
            this.$window.location.assign(href);
            this.$window.location.reload();
        }
    }, {
        key: 'loadMore',
        value: function loadMore() {
            var _this3 = this;

            if (this.loading) return;
            this.searchCriteria.Offset = this.results.length;
            this.load(this.searchCriteria).then(function (results) {
                _this3.results = _this3.results.concat(results);
                if (_this3.needCombination) {
                    _this3.combineResults();
                }
            });
        }

        // Gets total payment sum, including payment fee (credit card fee)

    }, {
        key: 'getTotal',
        value: function getTotal() {
            return this.results && this.results.length > 0 ? this.results[0].Price + "€" : null;
        }
    }, {
        key: 'load',
        value: function load(searchCriteria) {
            var _this4 = this;

            //console.log("[WDL] load() running...");
            var language = this.localizationService.getLanguage();

            var reserveLink = true;
            if (this.withReserveLink === "false") {
                reserveLink = false;
            }

            if (this.ignoreCapacity === 'true') {
                searchCriteria.IgnoreCapacity = true;
            }

            if (this.ignoreClosingDate === 'true') {
                searchCriteria.IgnoreClosingDate = true;
            }

            if (this.ignoreEverything === 'true') {
                searchCriteria.IgnoreEverything = true;
            }

            if (this.requireCapacity === 'true') {
                searchCriteria.RequireCapacity = true;
            }

            if (this.requirePrice === 'true') {
                searchCriteria.RequirePrice = true;
            }

            if (this.withI8Link === 'true') {
                searchCriteria.LinkType = 'I8';
            }

            if (this.withAdditionalDescriptionLink === 'true') {
                searchCriteria.LinkType = 'AdditionalDescription';
            }

            if (!searchCriteria.StartDate) {
                searchCriteria.StartDate = moment().format('YYYY-MM-DD');
            }

            var params = this.winresReservationContext.getUrlParams();

            if (this.useCurrentStartDate === 'true') {
                searchCriteria.StartDate = params.StartDate;
            }

            if (this.winresReservationContext.Params.StopID != null) {
                searchCriteria.StopID = this.winresReservationContext.Params.StopID;
            }

            var search = void 0;
            if (this.useSearchDepartures === 'true') {
                search = this.departureService.searchReservableItemsWithSearchDepartures(searchCriteria, reserveLink, language);
            } else if (searchCriteria.Classifications1 !== undefined && _.some(searchCriteria.Classifications1, function (c) {
                return c === 'AK';
            })) {
                // Activity search.
                search = this.departureService.searchReservableItemsWithSearchDayCapacity(searchCriteria, reserveLink, language);
            } else {
                search = this.departureService.searchReservableItems(searchCriteria,
                /*withReserveLink=*/reserveLink, language);
            }

            this.loading++;
            this.loadingIndicators('enable');

            if (this.scrollBeforeSearch) {
                this.$timeout(function () {
                    var element = angular.element('#search-anchor-' + _this4.$scope.$id);
                    if (element) {
                        // scrollToElement is some Angular plugin, see package.json
                        _this4.$document.scrollToElement(element, 100, 1000);
                    }
                });
            }

            return search.then(function (response) {
                _this4.loading--;
                if (!_this4.loading || !response || response.Results) {
                    _this4.loadingIndicators('disable');
                }
                if (response) {
                    var results = response.Results;
                    var hasSeoLinks = results && response.HasSeoLinks;

                    _.each(results, function (result) {
                        return _this4.modifyResult(result, hasSeoLinks);
                    });

                    _this4.hasMore = response.HasMore;
                    if (searchCriteria.IsUserInitiated && _this4.scrollOnSearch === 'true') {
                        // Execute the scrolling in timeout since the anchor element
                        // does not necessarily exist before Angular is done modifying
                        // the HTML.
                        _this4.$timeout(function () {
                            var element = angular.element('#search-anchor-' + _this4.$scope.$id);
                            if (element) {
                                // scrollToElement is some Angular plugin, see package.json
                                _this4.$document.scrollToElement(element, 0, 1000);
                            }
                        });
                    }

                    // Post get description, headline and internet classifications
                    // because SearchDepartures does not return them
                    if (_this4.useSearchDepartures === 'true') {

                        // Show departures after receiving info
                        if (_this4.waitDeparturesInfo === 'true') {
                            _this4.loading++;
                            _this4.loadingIndicators('enable');
                            return _this4.getDeparturesInfo(results, language).then(function () {
                                _this4.loading--;
                                _this4.loadingIndicators('disable');
                                return results;
                            });
                        }

                        _this4.getDeparturesInfo(results, language);
                    }

                    // Reservation link of current departure
                    _this4.getCurrentDepartureLink(results);

                    return results;
                } else if (response === undefined) {
                    console.log("[WDL] load(): Response was undefined. Request was perhaps cancelled. Response was:", response);
                }
                // This function previously had no return at all, which was equivalent
                // to returning undefined.
                // Added return to make the situation explicit.
                // Change this if something else should be returned instead.
                return undefined;
            }).catch(function (error) {
                console.error("[WDL] Search failed. Error:", error);
            });
        }
    }, {
        key: 'getCurrentDepartureLink',
        value: function getCurrentDepartureLink(results) {
            var params = this.winresReservationContext.getUrlParams();

            var departure = _.find(results, function (result) {
                return params.DestinationCode === result.Destination.DestinationCode && (0, _utils.formatISODate)(params.StartDate) === (0, _utils.formatISODate)(result.StartDate) && (0, _utils.formatISODate)(params.EndDate) === (0, _utils.formatISODate)(result.EndDate);
            });

            if (departure) {
                this.departureReservationLink = departure.ReservationLink;
            }
        }
    }, {
        key: 'updateDescription',
        value: function updateDescription(result) {
            var description;
            switch (this.descriptionSource) {
                case 'headline':
                    description = result.Destination.Headline;
                    break;
                case 'description':
                default:
                    description = result.Destination.DescriptionOfDestination;
            }

            // Remove placeholder for imagegallery (with a case-insensitive regex)
            description = description.replace(/\[kuvat\]/i, '');

            //Shorten the text
            var numChars = 400;
            if (this.descriptionLength) {
                numChars = parseInt(this.descriptionLength) || 400;
            }

            if (numChars && description.length > numChars) {
                description = description.substr(0, numChars + 1).replace(/( | *[^ ]+)$/, '') + '...';
            }

            if (this.removeHtmlFromDescription === "true") {
                description = this.trump(description, ['hinta', 'price']);
            }

            result.Description = description;
        }
    }, {
        key: 'modifyResult',
        value: function modifyResult(result, hasSeoLinks) {
            //console.log("[WDL] Modify result running... ", result);
            try {
                if (result.EndDate && new Date(result.EndDate).getFullYear() > 1900 && (!result.Product || !result.Product.ForceReservedDays)) {
                    result.DateRange = (0, _utils.formatDateRange)(result.StartDate, result.EndDate);
                } else if (result.StartDate) {
                    result.DateRange = (0, _utils.formatFinnishDatePretty)(result.StartDate);
                } else {
                    result.DateRange = '';
                }
            } catch (e) {
                console.error(e);
            }

            // Calculate weeks and days between start and end date.
            if (result.StartDate && result.EndDate) {
                var startDate = moment(result.StartDate);
                var endDate = moment(result.EndDate);
                result.Weeks = endDate.diff(startDate, 'week');
                result.Days = endDate.diff(startDate, 'day');
            }

            // Capacity color codes. For example less capacity = more red.
            if (result.Capacity && !isNaN(result.Capacity.Available)) {
                result.Capacity.ColorCode = 2;
                if (result.Capacity.Available <= 0 || !result.Capacity.IsEnough) result.Capacity.ColorCode = 0;else if (result.Capacity.Available < Number(this.capacityBreakPoint)) result.Capacity.ColorCode = 1;
            }

            this.updateDescription(result);

            // Prevent modifying reservation link
            // 2020-07-23: Added the hasSeoLinks parameter for temporary
            // backwards compatibility.
            // See https://trello.com/c/099DkhdD
            // Remove the parameter once all customers have up-to-date URL templates.
            if (this.withReserveLink === 'true' && hasSeoLinks || this.withI8Link === 'true' || this.withAdditionalDescriptionLink === 'true' || result.Product && result.Product.UsesTimeSlots) {
                return;
            }

            //console.log("this.reservationLinkTemplate is: ", this.reservationLinkTemplate);

            // Case when the URL is defined in winres database (and the withReservationLink = true)
            if (result.ReservationLink) {
                if (this.reservationLinkTemplate === null || this.reservationLinkTemplate === undefined) {

                    if (this.useSeoLinks && result.ReservationLink.indexOf('#') != -1) {
                        var origResLink = result.ReservationLink;
                        //console.log("[WDL] Original reservation link is: ", origResLink);
                        var reservationLinkBasePart = origResLink.split('#')[0];
                        var reservationLinkEndPart = origResLink.split('#')[1].split('!')[1];
                        //console.log("[WDL] reservationLinkEndPart: ", reservationLinkEndPart);
                        var destNameforUrl = (0, _utils2.removeSpecialChars)(result.Destination.DestinationName);

                        result.ReservationLink = reservationLinkBasePart + "#!/" + destNameforUrl + reservationLinkEndPart;
                        //console.log("[WDL] New reservationLink is: ", result.ReservationLink);
                    }
                }
            }

            // Case when reservationLinkTemplate is given in the parameter, not getting URL from winres database
            if (this.reservationLinkTemplate !== null && this.reservationLinkTemplate !== undefined) {

                var currentUrl = this.$window.location.href;
                //console.log("[WDL] this.$window.location.href: ", this.$window.location.href);

                if (currentUrl.indexOf('?') != -1) {
                    var currentUrl = this.trump(currentUrl, '?');
                    //console.log("[WDL] currentURL set to: ", currentUrl);
                }

                if (this.reservationLinkTemplate.indexOf('http') === -1) {
                    //console.log("[WDL] this.reservationLinkTemplate: ", this.reservationLinkTemplate);
                    //console.log("[WDL] this.reservationLinkTemplate.indexOf('http') === -1");
                    if (this.reservationLinkTemplate.indexOf('../') !== -1) {
                        //console.log("[WDL] this.reservationLinkTemplate.indexOf('../') !== -1");
                        var _reservationLinkBasePart = currentUrl.split('#')[0];
                        //const reservationLinkEndPart = "#" + currentUrl.split('#')[1];
                        //var s = currentUrl;
                        var s = _reservationLinkBasePart;
                        //console.log("[WDL] s is 1: ", JSON.stringify(s));
                        s = s.substring(0, s.lastIndexOf("/"));
                        //console.log("[WDL] s is 2: ", JSON.stringify(s));
                        //console.log("[WDL] s.substring(0, s.lastIndexOf(\"/\")): ", s.substring(0, s.lastIndexOf("/")));
                        //console.log("[WDL] this.reservationLinkTemplate.substring(2, this.reservationLinkTemplate.length): ", this.reservationLinkTemplate.substring(2, this.reservationLinkTemplate.length));
                        this.reservationLinkTemplate = s.substring(0, s.lastIndexOf("/")) + this.reservationLinkTemplate.substring(2, this.reservationLinkTemplate.length);
                        //console.log("[WDL] this.reservationLinkTemplate: ", this.reservationLinkTemplate);
                    } else {
                        this.reservationLinkTemplate = currentUrl + this.reservationLinkTemplate;
                        //console.log("[WDL] else.. this.reservationLinkTemplate: ", this.reservationLinkTemplate);
                    }
                }

                var numAdults = this.searchCriteria ? this.searchCriteria.NumAdults : 0;
                var numChildren = this.searchCriteria ? this.searchCriteria.NumChildren : 0;
                var numInfants = this.searchCriteria ? this.searchCriteria.NumInfants : 0;

                if (this.useSeoLinks) {
                    //console.log("[WDL] useSeoLinks!");
                    if (result.Departure == null && this.noDatesForDayCapacity === 'true') {
                        //console.log("[WDL] 1 result.Departure == null && this.noDatesForDayCapacity === 'true");
                        result.ReservationLink = this.reservationLinkTemplate + '/#!/' + (0, _utils2.removeSpecialChars)(result.Destination.DestinationName) + '/' + result.Destination.DestinationCode + '///2';
                    } else if (result.Departure == null && this.noDatesForDayCapacity !== 'true') {
                        //console.log("[WDL] 2 result.Departure == null && this.noDatesForDayCapacity !== 'true')");
                        result.ReservationLink = this.reservationLinkTemplate + '/#!/' + (0, _utils2.removeSpecialChars)(result.Destination.DestinationName) + '/' + result.Destination.DestinationCode + '/' + this.$filter('date')(result.StartDate, 'yyyy-M-d') + '/' + this.$filter('date')(result.EndDate, 'yyyy-M-d') + '/' + numAdults + '/' + numChildren + '/' + numInfants;
                    } else {
                        //console.log("[WDL] 3 else");
                        result.ReservationLink = this.reservationLinkTemplate + '/#!/' + (0, _utils2.removeSpecialChars)(result.Destination.DestinationName) + '/departure/' + result.Departure.DestinationCode + '/' + this.$filter('date')(result.Departure.DepartureDate, 'yyyy-M-d') + '/' + this.$filter('date')(result.Departure.ArrivalDate2, 'yyyy-M-d') + '/' + numAdults + '/' + numChildren + '/' + numInfants;
                    }
                } else {
                    if (result.Departure == null && this.noDatesForDayCapacity === 'true') {
                        result.ReservationLink = this.reservationLinkTemplate + '/#!/' + result.Destination.DestinationCode + '///2' /*+'/'+this.$filter('date')(result.Destination.DepartureDate, 'yyyy-M-d')+'/'+this.$filter('date')(result.Destination.ArrivalDate2, 'yyyy-M-d')+'/'+this.searchCriteria.NumAdults+'/'+this.searchCriteria.NumChildren+'/'+this.searchCriteria.NumInfants*/;
                    } else if (result.Departure == null && this.noDatesForDayCapacity !== 'true') {
                        result.ReservationLink = this.reservationLinkTemplate + '/#!/' + result.Destination.DestinationCode + '/' + this.$filter('date')(result.StartDate, 'yyyy-M-d') + '/' + this.$filter('date')(result.EndDate, 'yyyy-M-d') + '/' + this.searchCriteria.NumAdults + '/' + this.searchCriteria.NumChildren + '/' + this.searchCriteria.NumInfants;
                    } else {
                        result.ReservationLink = this.reservationLinkTemplate + '#!/departure/' + result.Departure.DestinationCode + '/' + this.$filter('date')(result.Departure.DepartureDate, 'yyyy-M-d') + '/' + this.$filter('date')(result.Departure.ArrivalDate2, 'yyyy-M-d') + '/' + this.searchCriteria.NumAdults + '/' + this.searchCriteria.NumChildren + '/' + this.searchCriteria.NumInfants;
                    }
                }
            }

            /*
            *  Make reservations links (links to products page in the listing)
            *  compatible with Wordpress multilingual plugin WPML
            *  it need the ?lang=XX parameter added.
            *  (WPML can also be configured to use subfolder example.com/XX/content format)
            * */
            //Check if WPML is enabled
            if (document.querySelector("meta[name=generator][content^='WPML']")) {
                //Check if this has already run, or that ?lang= is not already otherwise present
                if (result.ReservationLink && result.ReservationLink.indexOf("?lang=") == -1) {
                    var _reservationLinkBasePart2 = result.ReservationLink.split('#')[0];
                    var _reservationLinkEndPart = "#" + result.ReservationLink.split('#')[1];
                    var langParameter = "?lang=";
                    var langCode = this.localizationService.getLanguage();
                    var reservationLinkWithLang = _reservationLinkBasePart2 + langParameter + langCode + _reservationLinkEndPart;
                    result.ReservationLink = reservationLinkWithLang;
                    //console.log("added lang to reservation link: " + result.ReservationLink + " --> " + reservationLinkWithLang);
                }
            }
        }
    }, {
        key: 'getDeparturesInfo',
        value: function getDeparturesInfo(results, language) {
            var _this5 = this;

            console.log("[WDL] getDeparturesInfo", results);

            var destinationCodes = results.map(function (result) {
                return result.Destination.DestinationCode;
            });
            return this.departureService.getDeparturesInfo(destinationCodes, language).then(function (info) {
                _.each(results, function (result) {
                    var selected = _.find(info, function (i) {
                        return result.Destination.DestinationCode == i.DestinationCode;
                    });

                    result.Destination.Headline = selected.Headline;
                    result.Destination.DescriptionOfDestination = selected.Description;
                    result.Destination.InternetClassifications = selected.InternetClassifications;

                    _this5.updateDescription(result);
                });

                return info;
            });
        }
    }, {
        key: 'trump',
        value: function trump(str, pattern) {
            var trumped = "";

            if (str && str.length) {
                trumped = str;
                if (pattern && pattern.length) {
                    for (var i = 0; i < pattern.length; i++) {
                        var idx = str.toLowerCase().indexOf(pattern[i]);

                        if (idx != -1) {
                            trumped = str.substring(0, idx);
                        }
                    }
                }
            }
            return trumped;
        }
    }, {
        key: 'combineResults',
        value: function combineResults() {
            var _this6 = this;

            this.combinedResults = [];
            _.each(this.results, function (result) {
                var r = _.find(_this6.combinedResults, function (result2) {
                    return result2.Code == result.Destination.InternetClassifications[0].Code + result.Destination.InternetClassifications[4].Code + result.StartDate;
                });
                if (r) {
                    r.variations.push(result);
                } else {
                    _this6.combinedResults.push(result);
                    result.Code = result.Destination.InternetClassifications[0].Code + result.Destination.InternetClassifications[4].Code + result.StartDate;
                    result.variations = [];
                    result.variations.push(result); //has to be in both layers, top and variations
                }
                result.days = Math.round(Math.abs((new Date(result.EndDate).getTime() - new Date(result.StartDate).getTime()) / (24 * 60 * 60 * 1000))); //last is day length
            });
            //console.log("Combined", this.combinedResults)
        }
    }, {
        key: 'getNoResultText',
        value: function getNoResultText() {
            if (!this.noResultsText) this.noResultsText = this.$filter('i18next')('winres_departures.no_departures_found');
        }
    }, {
        key: 'isPriceDisplayed',
        value: function isPriceDisplayed(price) {
            if (this.hidePriceWhenNotReservable !== 'true') {
                return true;
            } else if (price == 0) {
                return false;
            }
            return true;
        }
    }, {
        key: 'getPriceLabel',
        value: function getPriceLabel(result) {
            if (!result) return '';

            var translate = this.$filter('i18next');

            if (result.IsPreview) {
                return translate('winres_departures.preview');
            } else if (result.Departure && result.Departure.PriceFrom2hh) {
                return translate('winres_departures.priceFrom2hh');
            } else {
                return translate(result.PriceDescription);
            }
        }
    }, {
        key: 'getPriceAmount',
        value: function getPriceAmount(result) {
            var _this7 = this;

            if (!result) return '';

            var filter = function filter(x) {
                return _this7.$filter('trimdecimals')(_this7.$filter('number')(x, 2)) + '€';
            };

            if (result.IsPreview) {
                return '';
            } else if (result.Departure && result.Departure.PriceFrom2hh) {
                return filter(result.Departure.PriceFrom2hh, 2);
            } else {
                return filter(result.Price, 2);
            }
        }
    }, {
        key: 'getCapacityText',
        value: function getCapacityText(result) {
            // This function used to take result.Capacity.Available rather than result.
            // In case there are some old templates outside this repository that call
            // this function, log a warning and try to adapt.
            if (_.isInteger(result)) {
                console.warn('[WDL] getCapacityText was called with an integer. Templates should be changed to call it with the full result object.');
                result = {
                    IsPreview: false, // No knowledge about this so default to false
                    Capacity: {
                        Available: result
                    }
                };
            }

            if (this.capacityFullText == '' || this.capacityBreakPointText == '' || this.capacityNumber == '' || this.enoughCapacity == '' || this.capacityBreakPoint == '') {
                return '';
            }

            var isPreview = result && result.IsPreview;

            if (isPreview) {
                return this.$filter('i18next')('winres_departures.preview');
            }

            var capacity = result && result.Capacity ? result.Capacity.Available : 0;

            if (capacity == 0) {
                return this.$filter('i18next')(this.capacityFullText);
            } else if (this.capacityBreakPoint >= capacity) {
                return (this.capacityNumber ? capacity : '') + this.$filter('i18next')(this.capacityBreakPointText);
            } else {
                return this.$filter('i18next')(this.enoughCapacity);
            }
        }
    }, {
        key: 'getHowMuchSpaceIsLeftText',
        value: function getHowMuchSpaceIsLeftText() {
            if (this.spaceLeftText != "") {
                return this.spaceLeftText;
            } else if (this.data.SelectedDeparture != null) {
                if (this.data.SelectedDeparture.CapacityAvailable == 0 || this.data.SelectedDeparture.CapacityAvailable == null) {
                    this.spaceLeftText = this.$filter('i18next')(this.capacityFullText);
                    return this.$filter('i18next')(this.capacityFullText);
                } else if (this.capacityBreakPoint >= this.data.SelectedDeparture.CapacityAvailable) {
                    //var capacityAvailable = this.data.SelectedDeparture.CapacityAvailable;
                    //if(!capacityAvailable)
                    //    capacityAvailable = 0;
                    //this.spaceLeftText = (this.capacityNumber ? capacityAvailable : '') + this.$filter('i18next')(this.capacityBreakPointText);
                    this.spaceLeftText = (this.capacityNumber ? this.data.SelectedDeparture.CapacityAvailable : '') + this.$filter('i18next')(this.capacityBreakPointText);
                    return (this.capacityNumber ? this.data.SelectedDeparture.CapacityAvailable : '') + this.$filter('i18next')(this.capacityBreakPointText);
                } else {
                    this.spaceLeftText = this.$filter('i18next')(this.enoughCapacity);
                    return this.$filter('i18next')(this.enoughCapacity);
                }
            }
        }
    }, {
        key: 'getReservableProducts',
        value: function getReservableProducts(params, cacheKey) {
            var language = this.localizationService.getLanguage();
            params.MinCapacity = 1;
            return this.productService.getReservableProducts(params, language, cacheKey);
        }
    }, {
        key: 'addMultipleToCart',
        value: function addMultipleToCart(result, price, productAmount) {
            var _this8 = this;

            var params = {
                DestinationCode: result.Destination.DestinationCode,
                ProductCode: result.Product.DestinationInfo.ProductCode,
                StartDate: result.StartDate,
                EndDate: result.EndDate,
                NumAdults: 2,
                NumChildren: 0,
                NumInfants: 0
            };

            var cacheKey = params.DestinationCode + '|' + params.StartDate + '|' + params.EndDate;

            this.getReservableProducts(params, cacheKey).then(function (products) {
                if (products.length === 0) {
                    console.log('[WDL] Product seems to be unavailable. Parameters:', params);
                    return;
                } else if (products.length !== 1) {
                    console.error('[WDL] GetReservableProducts should return exactly one result here!', 'Parameters:', params, 'Results:', products);
                    return;
                }
                _this8.retrievedProduct = products[0];
                var res = _this8.winresReservationContext;
                var line = res.findOrCreateProductLineByProduct(_this8.retrievedProduct);
                _this8.addToCart(line, productAmount, price);
            });
        }
    }, {
        key: 'addToCart',
        value: function addToCart(line, productAmount, price) {
            var _this9 = this;

            var res = this.winresReservationContext;
            // Temporary check until multiple product support is implemented for Opera.
            if (this.allowBookingOnlyOne(this.retrievedProduct) && line.Amount > 0) {
                console.warn('[RDL] Can only book one of this product.');
                return;
            }
            line.TotalPrice = 0;
            line.UnitPrice = null;
            var passengerAssignments = [];
            var price = price;
            var chosenAmount = productAmount;
            if (chosenAmount > 0) {
                line.UnitPrice = price.Price;
                if (this.useDummyPassengers(this.retrievedProduct)) {
                    ++line.Amount;
                    var productNumber = line.Amount;
                    console.log('[WDL] Selected product is an Opera product. Assigning dummy passengers.');
                    this.assignDummyPassengersToProductLine(line, productNumber);
                } else {
                    res.addExtraServiceToPassenger(this.retrievedProduct, 0, chosenAmount, null, null);
                }
                if (price.Index !== null) {
                    var priceSelection = res.findOrCreatePriceSelection(price.Index, line);
                    priceSelection.Amount += chosenAmount;
                    //console.log(priceSelection);
                }

                line.TotalPrice += chosenAmount * price.Price;
                line.TaxPercent = this.TaxPercent;
            }

            // Set TotalPrice (and possibly UnitPrice) if the line has price selections
            (0, _utils2.setLinePricesFromPriceSelections)(line);

            this.$scope.justAddedToCart = true;
            this.$timeout(function () {
                _this9.$scope.justAddedToCart = false;
            }, 5000);

            //console.log('calling onAdd');
            //this.onAdd({'window': window});
            //console.log('after calling onAdd');
        }
    }, {
        key: 'assignDummyPassengersToProductLine',
        value: function assignDummyPassengersToProductLine(productLine, productNumber) {
            var passengerAmounts = {
                adults: this.data.NumAdults || 0,
                children: this.data.NumChildren || 0,
                infants: this.data.NumInfants || 0
            };
            // console.log('[WRT] Assigning dummy passengers. Amounts:', passengerAmounts);
            var eventDate = moment(productLine.Product.BeginDate);
            var res = this.winresReservationContext;
            var passengerIndexes = res.getOrCreateDummyPassengers(eventDate, passengerAmounts, this.data.ChildrenAges);
            productLine.PassengerAssignments = _.map(passengerIndexes, function (index) {
                return {
                    PassengerNumber: index,
                    ProductNumber: productNumber,
                    Comment: null,
                    Comment2: null
                };
            });
            //console.log('[WRT] Assigned', passengerIndexes.length, 'dummy passengers.');
            // console.log('[WRT] Product line:', productLine);
            // console.log('[WRT] All passengers:', this.data.Passengers);
        }

        // Temporary solutions for Opera problems. Should be replaced with something
        // more permanent if they are still needed later.

    }, {
        key: 'useDummyPassengers',
        value: function useDummyPassengers(product) {
            return this.isOperaProduct(product);
        }
    }, {
        key: 'allowBookingOnlyOne',
        value: function allowBookingOnlyOne(product) {
            return this.isOperaProduct(product);
        }
    }, {
        key: 'isOperaProduct',
        value: function isOperaProduct(product) {
            return product.DataSources && product.DataSources.Capacity === "Opera";
        }

        // Functions used in the filters copied from winresDestinationFilter

    }, {
        key: 'onSearchTermSubmit',
        value: function onSearchTermSubmit() {
            if (this.$scope.activeFilters.searchFieldTerm && this.$scope.activeFilters.searchFieldTerm !== '') {
                var activeFiltersCopy = this.$scope.activeFilters;
                activeFiltersCopy.searchTerms.push(this.$scope.activeFilters.searchFieldTerm);
                activeFiltersCopy.searchFieldTerm = '';
                this.$scope.activeFilters = activeFiltersCopy;
            }
        }
    }, {
        key: 'removeSearchTerm',
        value: function removeSearchTerm(index) {
            if (this.$scope.activeFilters.searchTerms.length > index) {
                var activeFiltersCopy = this.$scope.activeFilters;
                activeFiltersCopy.searchTerms.splice(index, 1);
                this.$scope.activeFilters = activeFiltersCopy;
            }
        }
    }, {
        key: 'scrollToTabs',
        value: function scrollToTabs() {
            var tab = document.getElementsByTagName("winres-reservation-shopping-tabs")[0];
            if (tab) {
                var oldPadding = tab.style.padding;
                tab.style.padding = window.innerHeight - 220 + "px"; // add scroll height.
                tab.scrollIntoView({ behavior: "smooth", block: "end", inline: "nearest" });
                tab.style.padding = oldPadding;
            }
        }
    }, {
        key: 'forceFullPagereloadFromResults',
        value: function forceFullPagereloadFromResults() {
            var href = window.location.href;
            //href = href.replace("/:tab", "");
            var destinationCode = this.data.SelectedDeparture.DestinationCode;
            var datesAndPeople = href.split(destinationCode)[1].substring(1);
            datesAndPeople = datesAndPeople.substring(0, datesAndPeople.length - 5); // subtract 0/0/0 at end of url.
            datesAndPeople += this.searchCriteria.NumAdults + '/';
            datesAndPeople += this.searchCriteria.NumChildren + '/';
            datesAndPeople += this.searchCriteria.NumInfants;
            var link = href.split('#!');
            var rest = link[1].split(destinationCode)[0] + destinationCode + "/";
            var reservationLink = '#!' + rest + datesAndPeople;

            // Identical url.
            //var noTabHash = window.location.hash.replace("/:tab", "");
            var oldLink = window.location.hash;
            if (oldLink == reservationLink) {
                //this.loading = 0;
                this.forceFullPagereloadWhenGettingResult = false;
                this.$rootScope.$broadcast("stop-loading-people"); // Hide OK button loading indicator.
                return;
            }

            //reservationLink+=this.addUrl; // add /:tab end of url.

            //var reservationLink = window.location.hash; // href.
            if (reservationLink) {
                console.log("[WDL] MAKING FORCED PAGE RELOAD to URL: ", reservationLink);

                window.location.hash = reservationLink; // change visible url without reload.

                // force full page reload using the link that was gotten from search results
                this.$window.location.assign(reservationLink);
                // location.assign is not enough because only the hash changes and angular thinks no reload is needed
                this.$window.location.reload();
            } else if (!reservationLink) {
                console.error("No reservation link, cannot force reload");
            } else {
                console.error("forceFullPagereloadWhenGettingResult error");
            }
        }
    }, {
        key: 'loadingIndicators',
        value: function loadingIndicators(state) {
            var htmlBody = angular.element(document.querySelector('body'))[0];
            var depListHtmlElement = angular.element(document.querySelector('.departure-list'))[0];
            if (state === 'enable') {
                // Set mouse cursor to 'wait'
                htmlBody.style.cursor = 'wait';
                // Set some loading styles for departureslist
                //depListHtmlElement.style.opacity = '0.5';
                //depListHtmlElement.style.backgroundColor = 'rgba(0,0,0,0.15)';
            }
            if (state === 'disable') {
                htmlBody.style.cursor = '';
                //depListHtmlElement.style.opacity = '';
                //depListHtmlElement.style.backgroundColor = '';
            }
        }

        // Ahtari HH code filtering.

    }, {
        key: 'filterHHCodes',
        value: function filterHHCodes(result) {
            var limits = {
                '1HH': 1,
                '1HHSUP': 1,
                '2HH': 2,
                '2HHSUP': 2,
                '3HH': 3,
                '3HHSUP': 3,
                'HH': 4,
                'HHSUP': 4
            };

            var hhcode = result.Destination.DestinationCode;

            var limit = limits[hhcode];
            if (limit === undefined) {
                // Room type not in list
                return true;
            }

            var adults = this.searchCriteria.NumAdults;
            var people = adults + this.searchCriteria.NumChildren;

            var familyRoom = limit === 4;
            var tooManyAdultsInFamilyRoom = familyRoom && adults > 2;

            return people === limit && !tooManyAdultsInFamilyRoom;
        }
    }, {
        key: 'getPriceEur',
        value: function getPriceEur(price) {
            // const decimalPlaces = _.isInteger(price.Price) ? 0 : 2;
            var decimalPlaces = 2;
            return this.$filter('currency')(price, '€', decimalPlaces);
        }
    }, {
        key: 'getWinresParams',
        value: function getWinresParams() {
            var _this10 = this;

            this.paramService.getWinresParam('CanShowProductName').then(function (param) {
                _this10.showProductName = param.toUpperCase() === 'TRUE';
            });

            this.paramService.getWinresParam('CanShowActivities').then(function (param) {
                _this10.showActivities = param.toUpperCase() === 'TRUE';
            });
        }
    }]);

    return WinresDeparturesListController;
}();

String.prototype.replaceAll = function (search, replacement) {
    var target = this;
    return target.replace(new RegExp(search, 'g'), replacement);
};

WinresDeparturesListController.$inject = ['$document', '$scope', '$timeout', 'departureService', 'localizationService', '$attrs', '$filter', 'productService', '$window', '$rootScope', 'cancelService', 'paramService'];

function getTemplate($attrs, $sce) {
    return $attrs.templateUrl ? $sce.trustAsResourceUrl((0, _utils2.getWebcomponentsUrl)($attrs.templateUrl)) : 'departures-list-' + $attrs.mode;
}

getTemplate.$inject = ['$attrs', '$sce'];

_module3.default.run(['$templateCache', function ($templateCache) {
    var blocks = require('./winresDeparturesListBlocks.html'),
        vertical = require('./winresDeparturesListVertical.html'),
        offers = require('./winresDeparturesListOffers.html'),
        departures = require('./winresDeparturesListDepartures.html'),
        table = require('./winresDeparturesListTable.html');

    // 2-blocks and 3-blocks point to the same template, the mode parameter
    // just controls how the Bootstrap grid is set up.
    $templateCache.put('departures-list-2-blocks', blocks);
    $templateCache.put('departures-list-3-blocks', blocks);
    $templateCache.put('departures-list-vertical', vertical);
    $templateCache.put('departures-list-offers', offers);
    $templateCache.put('departures-list-table', table);
    $templateCache.put('departures-list-departures', departures);
}]);

_module3.default.component('winresDeparturesList', {
    templateUrl: getTemplate,
    controller: WinresDeparturesListController,
    require: {
        winresReservationContext: '^^winresReservationContext'
    },
    bindings: {
        // Template to use. '2-blocks', '3-blocks', 'offers', 'table', 'vertical', 'departures'
        // Required unless template-url is specified.
        mode: '@',
        // If true, use the standard offers-search criteria. 
        // Use amount-of-next-departures as Limit in search criteria
        // Triggers search on init 
        offers: '@',
        // Binds search criteria. E.g. output of winresDeparturesSearch may
        // be passed here, or just some static value.
        searchCriteria: '<',
        // Number of characters to take from the start of description.
        // Default: 400
        descriptionLength: '@',
        // finds the first html tag and removes everything after that.
        removeHtmlFromDescription: '@',
        // Reserve links have target="_blank". Used in cases where the
        // departure list is shown on the customer's web page or somewhere other
        // than the reservation site. (e.g. links to Intres or something.)
        // Default: false
        reserveInNewWindow: '@',
        // Adds the destination loaded into the reservation context
        // (i.e. the destination of the current page) to search criteria. This
        // is used to show only departures of the current destination if the
        // user is allowed to select departure.
        // 26.10.2017 Apparently this doesn't do anything. Used for smth else: when used with nextDepartures, loads departures with the same destination code.
        // Use amount-of-next-departures as Limit in search criteria
        // Triggers search on init
        useCurrentDestination: '@',
        // Either 'description' (default) or 'headline'
        descriptionSource: '@',
        // If "true", automatically scrolls to results when the user searches.
        // Only applies to user-initiated searches, if the search component is
        // set to automatically search with defaults, doesn't scroll.
        scrollOnSearch: '@',
        // If "true", automatically scrolls to results when the user searches. This one scrolls before there are results.
        scrollBeforeSearch: '@',
        // In offers template, what to display before the price.
        // "Offer 99 €" or "Your text here 99 €"
        offerPriceText: '@',
        // Text to display when no results are found.
        noResultsText: '@',
        // replaces the string "Meno"
        departureDateString: '@',
        // replaces the string 'winres_departures.find_out_more'
        findOutMore: '@',

        // if true loads n next departures. 
        // Use earliestNDeparturesPerDestination as EarliestNDeparturesPerDestination in search criteria
        // Use amount-of-next-departures as Limit in search criteria
        // Triggers search on init 
        nextDepartures: '@',
        // used with nextDepartures to show next departures of specific int. class 1
        useSpecificClassification: '@',
        // used with nextDepartures to show next departures of specific int. class 2
        useSpecificClassification2: '@',
        // used with nextDepartures. Selects how many departures are loaded. Default 3.
        amountOfNextDepartures: '@',
        // used with nextDepartures.
        nextStartDate: '@',
        // used with nextDepartures.
        nextEndDate: '@',
        // used with nextDepartures.
        nextMinLength: '@',
        // used with nextDepartures.
        nextMaxLength: '@',

        // combines result by int. clas. 5, like in Stay & Play. ALL departures must have internet classification 5!
        needCombineResults: '@',
        // when true: hides the price when the product is not reservable. Default: false. This doesn't work always, hasn't been implemented to every possibility, go edit template.
        hidePriceWhenNotReservable: '@',
        // If true, ignores capacity in the searches. Default: false.
        ignoreCapacity: '@',
        // If true, ignores closing date in the searches. Default: false.
        ignoreClosingDate: '@',
        // To change the text 'winres_departures.next_departures' on top of the page.
        nextDeparturesText: '@',
        // true (default)/ false. If false, the reservelink is created in the front end.
        withReserveLink: '@',
        // Overrides the url returned by the BE, url of the kohdesivu/matkasivu, before /#!/.

        // if this does not have 'http' in the string (https also has the 'http' part in it) it will take current url and add the value of this to the end of it
        // also accepts ../ to go one "folder" up
        reservationLinkTemplate: '@',
        // if you don't want dates for the url of day capacity products. Used with reservationLinkTemplate
        noDatesForDayCapacity: '@',
        // false (default)/true
        displayPriceNote: '@',
        // Can show capacity-full-text
        showFullText: '@',

        // specify all of these if used in mode: departures
        // voluntary if mode is: table
        // example:
        //  capacity-break-point="6"
        //  enough-capacity="capacity.enough_capacity"
        //  capacity-number="true"
        //  capacity-break-point-text="capacity.places_left"
        //  capacity-full-text="capacity.full"
        // this is the amount of capacity when it changes from being "space left" to "not so much space left." "not so much space left" => full goes automatically when capacity == 0
        capacityBreakPoint: '@',
        // text for "space left"
        enoughCapacity: '@',
        // if "not so much space" shows exact amount left. true/false.
        capacityNumber: '@',
        // this is the text for "not so much space left"
        capacityBreakPointText: '@',
        // text for when departure is full
        capacityFullText: '@',
        // A number or not set. Limits the amount of departures that is displayed per destination
        earliestNDeparturesPerDestination: '@',
        // Month name for departure list blocks
        monthName: '@',
        // Always show reservable and not reservable results and hide showOnlyReservable checkbox. Used in ahtari packages.
        showReservableAndNotReservable: '@',
        // Use new fast departure search. Should be used whenever tested to work.
        useSearchDepartures: '@',
        // Wait for GetDeparturesInfo, then show results
        // Used by fast departure search
        waitDeparturesInfo: '@',
        // If true, requires capacity in the searches. Default: false.
        requireCapacity: '@',
        // If true, requires price in the searches. Default: false.
        requirePrice: '@',
        // Return Intres links
        withI8Link: '@',
        // Set SearchCritera StartDate from url
        useCurrentStartDate: '@',
        // If true, ignores everything in the searches. Default: false.
        ignoreEverything: '@',
        // If true, get reservation link lisakuvausurl. Default: false.
        withAdditionalDescriptionLink: '@',
        // If true, linkify destination name. Default: false.
        withNameDescriptionLink: '@'
    }
});


//////////////////
// WEBPACK FOOTER
// ./src/webComponents/components/winresDeparturesList/winresDeparturesList.js
// module id = 288
// module chunks = 2